import { render, staticRenderFns } from "./TransfersView.vue?vue&type=template&id=aa2c71a8&"
import script from "./TransfersView.vue?vue&type=script&lang=js&"
export * from "./TransfersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports